import { Capacitor } from "@capacitor/core";
import ons from "onsenui";
import React from "react";
import { openExternalUrl } from "../external_link";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { TIMES_SVG } from "../utils/svgs";
import { STAR_ICON } from "../utils/svgs_new";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import AppLogoIcon from "./Generic/AppLogoIcon";
import Flex from "./Generic/Flex";

const OpenInApp = () => {
  const [isClosed, setClosed] = React.useState(false);

  const isFromLocalhost = window.location.href.match(/^https?:\/\/localhost/) !== null;
  const platform = Capacitor.getPlatform();

  if (isFromLocalhost || platform !== "web" || isClosed) {
    return null;
  }

  const handleClickGetApp = () => {
    if (ons.platform.isAndroid()) {
      openExternalUrl("https://play.google.com/store/apps/details?id=com.medflyt.iphone");
    }

    if (ons.platform.isIOS()) {
      openExternalUrl("https://itunes.apple.com/us/app/medflyt/id1165814775?mt=8");
    }
  };

  return (
    <div className="OpenInApp">
      <Flex xGap={16} alignItems="center">
        <AppLogoIcon size={40} />
        <Flex alignItems="center" justifyContent="space-between" flex={1}>
          <Flex direction="column">
            <strong>MedFlyt</strong>
            <Flex>
              <AppIcon icon={STAR_ICON} fill="#FFB400" size={14} />
              <AppIcon icon={STAR_ICON} fill="#FFB400" size={14} />
              <AppIcon icon={STAR_ICON} fill="#FFB400" size={14} />
              <AppIcon icon={STAR_ICON} fill="#FFB400" size={14} />
              <AppIcon icon={STAR_ICON} fill="#FFB400" size={14} />
            </Flex>
          </Flex>
          <Flex alignItems="center">
            <AppButton size="small" onClick={handleClickGetApp}>
              {translate(STRINGS.GET_THE_APP)}
            </AppButton>
            <AppButton variant="link" onClick={() => setClosed(true)}>
              <AppIcon icon={TIMES_SVG} size={14} />
            </AppButton>
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
};

export default OpenInApp;
